export default [
  {
    path: 'printing/alert',
    name: 'PrintingAlert',
    component: () => import('@/views/Printing/Alert.vue'),
    props: true,
    meta: {
      name: 'printing-alert',

      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'alerts',
    name: 'alerts',
    component: () => import('@/views/Alert/Index.vue'),
    props: true,
    meta: {
      name: 'alert',
      has_auth: true,
      middleware: 'auth',
      template: 'auth',
    },
  },
  {
    path: 'alert-content/:alertId',
    name: 'alertContent',
    component: () => import('@/views/Alert/Show.vue'),
    props: true,
    meta: {
      name: 'alert',
      has_auth: true,
      middleware: 'auth',
      template: 'auth',
    },
  },
  {
    path: 'print-alert',
    name: 'printAlert',
    component: () => import('@/views/Printing/Alert.vue'),
    props: true,
    meta: {
      name: 'printing-alert',
      middleware: 'auth',
      template: 'printing',
    },
  },
];
